import Api from 'services/api';

export interface ProgramaIntegridadeSubmitPayload {
  nome: string;
  email: string;
  telefone: string;
  nome_empresa: string;
  cnpj: string;
  observacao?: string;
}

export const submitProgramaIntegridadeForm = async (payload: ProgramaIntegridadeSubmitPayload) => {
  const response = await Api.post('/programa_de_integridade/submit', payload);
  return response.data;
};
